export default "__VITE_ASSET__fLd6q4Td__"